'use client';

import { c as _c } from "react/compiler-runtime";
import { LocalizedLink } from '@src/components/LocalizedLink/LocalizedLink';
import { useTopNav } from '@src/components/TopNavV3/TopNavContext';
import { useTrackSelectNavCta } from '@src/utils/analytics.util';
export const TopNavMobileFooter = () => {
  const $ = _c(6);
  const trackSelectNavCta = useTrackSelectNavCta();
  const {
    mobileFooterLinks,
    setExpanded
  } = useTopNav();
  let t0;
  if ($[0] !== mobileFooterLinks || $[1] !== setExpanded || $[2] !== trackSelectNavCta) {
    t0 = mobileFooterLinks?.filter(_temp).map(item_0 => <LocalizedLink onClick={() => {
      trackSelectNavCta({
        "cta url": item_0.href
      });
      setExpanded(false);
    }} key={item_0?.title} href={item_0.href ?? ""} rel={item_0.newTab ? "noopener noreferrer" : ""} target={item_0.newTab ? "_blank" : "_self"}>{item_0.title}</LocalizedLink>);
    $[0] = mobileFooterLinks;
    $[1] = setExpanded;
    $[2] = trackSelectNavCta;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  let t1;
  if ($[4] !== t0) {
    t1 = <footer className="flex flex-col gap-3 border-t border-white/10 p-4 pt-8 text-bodi-gray-butters">{t0}</footer>;
    $[4] = t0;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
};
function _temp(item) {
  return Boolean(item.title);
}